export default __webpack_public_path__ + "static/media/E.12378669.svg";